import { ThunkDispatch } from 'redux-thunk';
import { fetchLearnerHasEnrolmentConsentPermission } from '../../../web/containers/LearnersConsentModal/dispatchers';
import { ReduxAction } from '../../actions';
import { ReduxState } from '../../state';

export const loadLearnersEmailConsentData = (
  dispatch: ThunkDispatch<ReduxState, void, ReduxAction>
): Promise<void> => {
  return dispatch(fetchLearnerHasEnrolmentConsentPermission());
};
